import { render, staticRenderFns } from "./LrPlusBenefits.vue?vue&type=template&id=19db8032&"
import script from "./LrPlusBenefits.vue?vue&type=script&lang=js&"
export * from "./LrPlusBenefits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports